import React from 'react';
import {
  formatDate,
  formatTime,
  getDayName,
  getReadableTimeDiff,
} from 'globals/utils';
import { Box } from '@material-ui/core';
import { Date, Time, Weekday } from './FsDate.style-elements';

interface FsDateProps {
  date: number;
  withTime?: boolean;
  withWeekday?: boolean;
  withYear?: boolean;
  showDifference?: boolean;
  color?: string;
}

const FsDate: React.FC<FsDateProps> = ({
  withTime = false,
  withYear = false,
  withWeekday = false,
  showDifference = false,
  color,
  date,
}) => {
  return (
    <Box color={color} component="p">
      {showDifference ? (
        <Date component="span">{getReadableTimeDiff(date)}</Date>
      ) : (
        <>
          <Date component="span">{formatDate(date, withYear)}</Date>
          {withWeekday && (
            <Weekday component="span">, {getDayName(date)}</Weekday>
          )}
          {withTime && <Time component="span">{formatTime(date)}</Time>}
        </>
      )}
    </Box>
  );
};

export default FsDate;
